import { Injectable } from '@angular/core';

import { map } from 'rxjs';

import { CamBaseService, GraphEndpoint, HandleSimpleRequest } from '@camelot/server';

import { Missionview } from './dto/mission';
import { GET_MISSION_VIEW } from './queries';

const belgiumCoords = [
  { lat: 50.8503, lng: 4.3517 }, // Bruxelles
  { lat: 51.2194, lng: 4.4025 }, // Anvers
  { lat: 50.6326, lng: 5.5797 }, // Liège
  { lat: 50.4674, lng: 4.8718 }, // Namur
  { lat: 51.0543, lng: 3.7174 }, // Gand
  { lat: 50.4114, lng: 4.4445 }, // Charleroi
  { lat: 50.9307, lng: 5.3325 }, // Hasselt
  { lat: 50.8798, lng: 4.7005 }, // Louvain
  { lat: 50.4542, lng: 3.9523 }, // Mons
  { lat: 50.7294, lng: 4.6144 }, // Wavre
  { lat: 50.6107, lng: 3.3899 }, // Tournai
  { lat: 51.0344, lng: 4.4786 }, // Malines
  { lat: 51.213, lng: 3.2247 }, // Bruges
  { lat: 50.5863, lng: 5.8619 }, // Verviers
  { lat: 51.0304, lng: 5.342 }, // Genk
  { lat: 51.3297, lng: 3.207 }, // Knokke-Heist
  { lat: 50.9671, lng: 4.8276 }, // Aarschot
  { lat: 50.5626, lng: 4.6989 }, // Gembloux
  { lat: 50.802, lng: 3.27 }, // Courtrai
  { lat: 51.2661, lng: 4.7786 }, // Turnhout
];

const graphEndpoint: GraphEndpoint = {
  clientName: 'missionViewService',
  endpoint: 'view',
};

@Injectable({
  providedIn: 'root',
})
export class CamMissionsViewService extends CamBaseService {
  protected _graphEndpoint = graphEndpoint;
  public missions = new HandleSimpleRequest<Missionview[]>();

  constructor() {
    super();
    super.registerRoutes({ graphEndpoint: graphEndpoint });
  }

  public fetchView$() {
    return this.missions.fetch(
      this._graphService
        .fetchPagedQueryList<Missionview>(GET_MISSION_VIEW(), 'missionView', graphEndpoint.clientName)
        .pipe(
          map(data =>
            (data.items ?? []).map(missionView => {
              const coord = belgiumCoords[Math.floor(Math.random() * belgiumCoords.length)];
              return {
                ...missionView,
                lat: coord.lat,
                lng: coord.lng,
              };
            })
          )
        )
    );
  }
}
